import { createFileRoute } from "@tanstack/react-router";
import { RequestsManager } from "@/components/admin/RequestsManager";

export const Route = createFileRoute("/admin/withdrawals")({ component: WithdrawalsAdmin });

function WithdrawalsAdmin() {
  return <RequestsManager title="Withdraw Requests" type="withdraw" />;
}
